import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BusinessOrgProfileService} from '../../../stores/services/business-org-profile.service';
import {IAccount} from '../../../stores/accounts/account';
import {Observable} from 'rxjs';
import {AuthenticationService} from 'src/app/core/authentication.service';

@Component({
    selector: 'app-retailer-select',
    templateUrl: './retailer-select.component.html',
    standalone: false
})
export class RetailerSelectComponent implements OnInit {
  @Input() controlName = 'retailer';
  @Input() controlLabel = 'Retailer';
  @Input() formGroup: FormGroup;
  @Input() model: any;
  @Input() multiple = false;
  @Input() accounts: IAccount[] = [];
  @Input() showAllOption = false;
  @Input() showNoneOption = false;
  @Input() isBrand = false;
  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() accountsChange: EventEmitter<IAccount[]> = new EventEmitter<IAccount[]>();
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() openedChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private accountsService: BusinessOrgProfileService,
    public authenticationService: AuthenticationService,
  ) {
  }

  onSelectionChanged(event) {
    this.selectionChange.emit(event);
    this.modelChange.emit(event.value);
  }

  ngOnInit() {
    this.loadAccounts();
    this.authenticationService.hookListActionOnOrgChange(() => {
      this.loadAccounts();
    });
  }

  onOpenedChanged(event) {
    this.openedChange.emit(event);
  }

  private loadAccounts() {
    const accounts: Observable<IAccount[]> = this.isBrand ? this.accountsService.getBrands() : this.accountsService.getRetailers();
    accounts.subscribe(
      (accounts) => {
        this.accounts = accounts;
        this.accountsChange.emit(accounts);
      });
  }
}
